import { useGetUnitTrafficSignalStrength } from '@apps-common/apis/portal/unit'
import { SectionTitle } from '@apps-common/components/common/portal-title'
import { VertSpacerLg } from '@apps-common/components/layout'
import { ModalButton } from '@apps-common/components/modals'
import { SignalStrengthChart, SignalStrengthKpi, SignalStrengthModal } from '@apps-common/components/modals/signal-strength-modal'
import { commonIcons } from '@apps-common/config/icons'
import { modalFadeInEnterAnimation, modalFadeInLeaveAnimation } from '@apps-common/lib/modal-animations'
import { IUnitGenericDetailsModel } from '@apps-common/types/portal/unit'

import { UnitContentCard } from '../UnitContentCard'

interface IProps {
  unit?: IUnitGenericDetailsModel
}

export const SignalStrengthCard: React.FC<IProps> = ({ unit }) => {
  const { ipAddress, imei } = unit || {}
  const { isLoading, isRefetching, isError, data, refetch } = useGetUnitTrafficSignalStrength({
    config: {
      enabled: !!unit
    },
    identifiers: `${ipAddress},${imei}`,
    skip: 0,
    take: 25
  })

  const loading = !unit || isLoading || isError

  return (
    <UnitContentCard classes='relative overflow-hidden h-full'>
      <div className='flex items-center justify-between'>
        <SectionTitle classes='relative z-[2] text-text ml-[10px]' text='Signal' />
        <div className='flex items-center justify-between gap-2'>
          <SignalStrengthKpi loading={loading} data={data} />
          <ModalButton
            component={SignalStrengthModal}
            disabled={loading}
            componentProps={{
              ipAddress,
              imei
            }}
            classes=''
            enterAnimation={modalFadeInEnterAnimation}
            leaveAnimation={modalFadeInLeaveAnimation}
          >
            <div className='bg-brand text-on-brand text-[1.2em] w-[35px] h-[35px] rounded-full flex items-center justify-center'>
              <commonIcons.arrowAngled />
            </div>
          </ModalButton>
        </div>
      </div>
      <VertSpacerLg />
      <div className='relative'>
        {!loading && data?.length === 0 && (
          <div className='absolute z-[5] top-0 left-0 w-full h-full bg-surface-2 flex items-center justify-center'>
            <div className='bg-surface border border-border px-4 py-3 rounded-xl jost-light'>No signals</div>
          </div>
        )}
        <SignalStrengthChart loading={loading} classes='w-full' chartClasses='!h-[220px]' data={data} />
      </div>
      <div className='jost-light text-[0.9rem] text-center mt-[10px]'>Signal strength by event</div>
    </UnitContentCard>
  )
}
